import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pen-icon',
  templateUrl: './pen-icon.component.html',
  styleUrls: ['./pen-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PenIconComponent {
  @Output() clickEvent = new EventEmitter();

  onClick(event: Event): void {
    event.stopPropagation();
    this.clickEvent.emit();
  }
}
